import React, { useEffect, useState } from 'react';
import { useNavigate} from "react-router-dom";
import Config from "../Config/Config";
import TabNavItem from "./TabComponent/TabNavItem";
import TabContent from "./TabComponent/TabContent";
import {FiBookOpen} from "react-icons/fi";
import {scrollFix} from "../Utilities/ScrollFix";
import {useTranslation} from "react-i18next";
import {Link, useParams} from "react-router-dom";
const parse = require('html-react-parser');

function Poi() {
    const {id} = useParams();
    const {t} = useTranslation('common');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('tab0');
    const navigate = useNavigate();

    const fetchData = () => {
        const slugParts = id.split('-');

        fetch(Config.baseUrl + '/datapoint/poi/' + slugParts[slugParts.length-1])
            .then((response) => {
                if (!response.ok) {
                    throw new Error(t('error'));
                }
                return response.json();
            })
            .then((data) => {
                if (data.data === null) {
                    navigate('/');
                }
                setData(data.data);
                setLoading(false);
                setError(null);
            })
            .catch((err) => {
                setError(err.message);
                setData(null);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        if (data.length === 0) {
            fetchData();
        }

        scrollFix();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, data.length]);

    if (loading) return <div>{t('please-wait')}</div>;
    if (error) return <div>{t('error')}</div>;

    return (
            <>
                <div className="poi">
                    <div className="poi-menu max-width">
                        <div className="flex">
                            <Link to={'/'} id="gotolist">  <FiBookOpen/> <span className="desktop">{t('back-to-overview')}</span>
                                <span className="mobile">{t('overview')}</span></Link>
                        </div>
                        <ul className="tabs flex">
                            {data.segments.map( (segment, index) => (
                                <TabNavItem key={index} title={segment.title} icon={segment.icon} id={'tab' + index} activeTab={activeTab} setActiveTab={setActiveTab}/>
                            ))}
                        </ul>
                        <h1>{data.title}</h1>
                    </div>
                    <div>
                        {data?.segments.map( (segment, index) => (
                            <TabContent key={index} activeTab={activeTab} id={'tab' + index}>
                                <div key={'content'+index} className="content">
                                    {parse(segment?.content ?? '')}
                                </div>
                            </TabContent>
                        ))}
                    </div>
                </div>
            </>
        )
}

export default Poi